// extracted by mini-css-extract-plugin
module.exports = {"video-wrapper":"YoutubeVideo_video-wrapper__RcHTM","landscape":"YoutubeVideo_landscape__agbKH"};